import config from '../../authentication/config';

export const isConfiguredParentAppDomain = value =>
    config.getParentAppDomain()?.includes(value) || value === window.origin;
